import { h } from 'preact'
import style from './styles/location.scss'
import Icon from '../Icon'

const Location = () => (
  <div class={style.normal}>
    <Icon icon="recommended" class={style.icon} />
    <span class={style.location}>Подбор недвижимости в москве и московской обл.</span>
  </div>
)

export default Location



// WEBPACK FOOTER //
// ./components/Header/Location.js